// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* analyze-detail.component.scss */
/* Container geral */
.analyze-dialog-content {
  padding: 0 24px 0 24px; /* ou ajuste conforme seu layout */
  min-width: 800px; /* largura mínima para caber todas as colunas */
}

/* =====================
   Cabeçalho
   ===================== */
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}
.header .space {
  width: 10px;
}
.header h1 {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  color: #000000;
}
.header .status {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #0074A9;
  font-size: 14px;
}
.header .status img {
  margin-right: 8px;
}

/* =====================
   Protocolo
   ===================== */
.protocol-row {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  width: 100%;
}
.protocol-row mat-form-field {
  width: 300px !important;
}
.protocol-row .tooltip-button {
  margin-left: 8px;
}

/* =====================
   Cabeçalho da “tabela”
   ===================== */
.table-header {
  min-width: 1300px;
  display: grid;
  grid-template-columns: 40px 300px 300px 300px 300px;
  align-items: center;
  font-weight: 600;
  color: #000000;
  padding: 8px 0;
  border-bottom: 1px solid #E0E0E0;
  background: #F4F4F4;
  height: 50px;
}
.table-header .col.col-check { /* coluna vazia para checkbox */ }
.table-header .col.col-item {
  padding-left: 24px;
}
.table-header .col.col-desc {
  padding-left: 24px;
}
.table-header .col.col-resp {
  padding-left: 24px;
}
.table-header .col.col-date {
  padding-left: 24px;
}

/* =====================
   Corpo (linhas) da “tabela”
   ===================== */
.table-body {
  max-height: 400px; /* se quiser rolar verticalmente */
}
.table-body .table-row {
  display: grid;
  grid-template-columns: 40px 300px 300px 300px 300px;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #F0F0F0;
  color: #000000;
  /* Ajuste de espaçamento interno */
  /* Se quiser cinza claro em hover: */
}
.table-body .table-row .col.col-item {
  padding-left: 24px;
  font-size: 14px;
}
.table-body .table-row .col.col-desc {
  font-size: 16px;
}
.table-body .table-row .col.col-desc, .table-body .table-row .col.col-resp, .table-body .table-row .col.col-date {
  padding-left: 24px;
}
.table-body .table-row:hover {
  background-color: #FAFAFA;
}

/* =====================
   Formulários internos
   ===================== */
.full-width {
  width: 100%;
}

.contract-field-prefix {
  font-size: 16px;
  font-weight: 500;
}

/* =====================
   Botões de ação
   ===================== */
.dialog-actions {
  margin-top: 16px;
  margin-bottom: 8px;
}

.buttons {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 32px;
}
.buttons .btn-back {
  width: 8rem !important;
}
.buttons a {
  text-decoration: none;
  color: #AE0F0A;
  margin-left: 32px;
}

::ng-deep.mat-mdc-form-field-subscript-wrapper {
  height: 0 !important;
}

::ng-deep.mdc-checkbox__native-control:enabled:checked ~ .mdc-checkbox__background {
  border-color: #AE0F0A !important;
  background-color: #AE0F0A !important;
}

.table-section {
  max-width: 100%;
  overflow-x: auto;
}

::ng-deep.mdc-tooltip__surface {
  white-space: pre-wrap;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center !important;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/shared/modals/analyze-detail/analyze-detail.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,kCAAA;AAEA,oBAAA;AACA;EACE,sBAAA,EAAA,kCAAA;EACA,gBAAA,EAAA,+CAAA;AACF;;AAEA;;0BAAA;AAGA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AACF;AACE;EACE,WAAA;AACJ;AACE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AACJ;AACE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AACJ;AAAI;EACE,iBAAA;AAEN;;AAIA;;0BAAA;AAGA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;AADF;AAEE;EACM,uBAAA;AAAR;AAEE;EACE,gBAAA;AAAJ;;AAIA;;0BAAA;AAGA;EACE,iBAAA;EACA,aAAA;EACA,mDAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;EACA,gCAAA;EACA,mBAAA;EACA,YAAA;AADF;AAII,+BAAA,+BAAA,EAAA;AACA;EAAa,kBAAA;AADjB;AAEI;EAAa,kBAAA;AACjB;AAAI;EAAa,kBAAA;AAGjB;AAFI;EAAa,kBAAA;AAKjB;;AADA;;0BAAA;AAGA;EACE,iBAAA,EAAA,kCAAA;AAIF;AAFE;EACE,aAAA;EACA,mDAAA;EACA,mBAAA;EACA,eAAA;EACA,gCAAA;EACF,cAAA;EACE,kCAAA;EAgBA,oCAAA;AAXJ;AAHM;EACE,kBAAA;EACA,eAAA;AAKR;AAHM;EACE,eAAA;AAKR;AAHM;EAGE,kBAAA;AAGR;AAEI;EACE,yBAAA;AAAN;;AAKA;;0BAAA;AAGA;EACE,WAAA;AAFF;;AAKA;EACE,eAAA;EACA,gBAAA;AAFF;;AAKA;;0BAAA;AAGA;EACE,gBAAA;EACA,kBAAA;AAFF;;AAIA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AADF;AAEE;EACE,sBAAA;AAAJ;AAEE;EACI,qBAAA;EACA,cAAA;EACA,iBAAA;AAAN;;AAGA;EACE,oBAAA;AAAF;;AAEA;EACE,gCAAA;EACA,oCAAA;AACF;;AACA;EACE,eAAA;EACE,gBAAA;AAEJ;;AAAA;EACE,qBAAA;EACE,aAAA;EAEA,uBAAA;EACA,mBAAA;EACA,6BAAA;AAEJ","sourcesContent":["/* analyze-detail.component.scss */\n\n/* Container geral */\n.analyze-dialog-content {\n  padding: 0 24px 0 24px; /* ou ajuste conforme seu layout */\n  min-width: 800px; /* largura mínima para caber todas as colunas */\n}\n\n/* =====================\n   Cabeçalho\n   ===================== */\n.header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 16px;\n\n  .space{\n    width: 10px;\n  }\n  h1 {\n    margin: 0;\n    font-size: 24px;\n    font-weight: 600;\n    color: #000000;\n  }\n  .status{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color: #0074A9;\n    font-size: 14px;\n    img{\n      margin-right: 8px;\n    }\n  }\n \n}\n\n/* =====================\n   Protocolo\n   ===================== */\n.protocol-row {\n  display: flex;\n  align-items: center;\n  margin-bottom: 24px;\n  width: 100%;\n  mat-form-field{\n        width: 300px !important;\n  }\n  .tooltip-button {\n    margin-left: 8px;\n  }\n}\n\n/* =====================\n   Cabeçalho da “tabela”\n   ===================== */\n.table-header {\n  min-width: 1300px;\n  display: grid;\n  grid-template-columns: 40px 300px 300px 300px 300px;\n  align-items: center;\n  font-weight: 600;\n  color: #000000;\n  padding: 8px 0;\n  border-bottom: 1px solid #E0E0E0;\n  background: #F4F4F4;\n  height: 50px;\n\n  .col {\n    &.col-check { /* coluna vazia para checkbox */ }\n    &.col-item { padding-left: 24px; }\n    &.col-desc { padding-left: 24px; }\n    &.col-resp { padding-left: 24px; }\n    &.col-date { padding-left: 24px; }\n  }\n}\n\n/* =====================\n   Corpo (linhas) da “tabela”\n   ===================== */\n.table-body {\n  max-height: 400px; /* se quiser rolar verticalmente */\n\n  .table-row {\n    display: grid;\n    grid-template-columns: 40px 300px 300px 300px 300px;\n    align-items: center;\n    padding: 12px 0;\n    border-bottom: 1px solid #F0F0F0;\n  color: #000000;\n    /* Ajuste de espaçamento interno */\n    .col {\n      &.col-item {\n        padding-left: 24px;\n        font-size: 14px;\n      }\n      &.col-desc{\n        font-size: 16px;\n      }\n      &.col-desc,\n      &.col-resp,\n      &.col-date {\n        padding-left: 24px;\n      }\n    }\n\n    /* Se quiser cinza claro em hover: */\n    &:hover {\n      background-color: #FAFAFA;\n    }\n  }\n}\n\n/* =====================\n   Formulários internos\n   ===================== */\n.full-width {\n  width: 100%;\n}\n\n.contract-field-prefix {\n  font-size: 16px;\n  font-weight: 500;\n}\n\n/* =====================\n   Botões de ação\n   ===================== */\n.dialog-actions {\n  margin-top: 16px;\n  margin-bottom: 8px;\n}\n.buttons{\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 32px;\n  .btn-back{\n    width: 8rem !important;\n  }\n  a {\n      text-decoration: none;\n      color: #AE0F0A;\n      margin-left: 32px;\n  }\n}\n::ng-deep.mat-mdc-form-field-subscript-wrapper{\n  height: 0 !important;\n}\n::ng-deep.mdc-checkbox__native-control:enabled:checked~.mdc-checkbox__background{\n  border-color: #AE0F0A !important;\n  background-color: #AE0F0A !important;\n}\n.table-section{\n  max-width: 100%;\n    overflow-x: auto;\n}\n::ng-deep.mdc-tooltip__surface {\n  white-space: pre-wrap;\n    display: flex\n;\n    justify-content: center;\n    align-items: center;\n    text-align: center !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
